import React, { Suspense, useState } from "react";
import IntersectionAnimationTrigger from "../IntersectorAnimationTrigger/IntersectorAnimationTrigger";

interface Props {
  children: React.ReactNode;
}

const AnimatedElement = ({ children }: Props) => {
  const [animated, setAnimated] = useState(false);

  const handleInView = () => {
    setAnimated(true);
  };

  return (
    <Suspense fallback={<div>Loading...</div>}>
      <IntersectionAnimationTrigger onInView={handleInView}>
        <div
          className={`animated-element ${
            animated ? "animate" : "disable_image_background"
          }`}
        >
          {children}
        </div>
      </IntersectionAnimationTrigger>
    </Suspense>
  );
};

export default AnimatedElement;
